import { render } from "./TransactionMessage.vue?vue&type=template&id=6932e551"
import script from "./TransactionMessage.vue?vue&type=script&lang=ts"
export * from "./TransactionMessage.vue?vue&type=script&lang=ts"
script.render = render

export default script